import React, { useState } from 'react';
import { motion } from 'framer-motion';

const MainContent: React.FC = () => {
  const [activeService, setActiveService] = useState<'software' | 'creative'>('software');

  const services = {
    software: {
      title: 'SOFTWARE ENGINEERING',
      items: [
        'WEB PLATFORMS',
        'CUSTOM APPLICATIONS',
        'API DEVELOPMENT',
        'PERFORMANCE OPTIMIZATION',
      ],
      description: 'Fast, performant web platforms and custom software solutions engineered for maximum efficiency.',
    },
    creative: {
      title: 'CREATIVE PRODUCTION',
      items: [
        'VIDEO PRODUCTION',
        'MOTION GRAPHICS',
        'BRAND IDENTITY',
        'DIGITAL CONTENT',
      ],
      description: 'Professional video production and creative media solutions for startups, corporate, and events.',
    },
  };

  return (
    <main id="services" className="main-content">
      <div className="content-wrapper">
        <div className="section-header">
          <span className="section-number">01</span>
          <h2 className="section-title">SERVICES</h2>
          <div className="section-line" />
        </div>

        <div className="service-tabs">
          <button
            className={`service-tab ${activeService === 'software' ? 'active' : ''}`}
            onClick={() => setActiveService('software')}
          >
            <span className="tab-indicator">{activeService === 'software' ? '●' : '○'}</span>
            SOFTWARE
          </button>
          <button
            className={`service-tab ${activeService === 'creative' ? 'active' : ''}`}
            onClick={() => setActiveService('creative')}
          >
            <span className="tab-indicator">{activeService === 'creative' ? '●' : '○'}</span>
            CREATIVE
          </button>
        </div>

        <motion.div
          key={activeService}
          className="service-content"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="service-grid">
            <div className="service-main">
              <h3 className="service-title">{services[activeService].title}</h3>
              <p className="service-description">{services[activeService].description}</p>

              <a href="mailto:admin@wetware.ai" className="cta-button">
                <span className="cta-text">GET IN TOUCH</span>
                <span className="cta-arrow">→</span>
              </a>
            </div>

            <div className="service-list">
              <div className="list-header">CAPABILITIES</div>
              <ul>
                {services[activeService].items.map((item, index) => (
                  <motion.li
                    key={item}
                    className="list-item"
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <span className="list-marker">—</span>
                    {item}
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>

        <div className="grid-decoration">
          <div className="grid-label">WETWARE.AI</div>
          <div className="grid-coords">51.5386°N, 0.1028°W</div>
        </div>
      </div>
    </main>
  );
};

export default MainContent;
